import React from 'react';

export function ProjectCard({ name = 'Projeto', status = 'Em andamento', phase = 1, totalPhases = 5, nextAction = null, items = [] }) {
  const pct = totalPhases > 0 ? Math.round((phase / totalPhases) * 100) : 0;
  return (
    <div style={{ margin: '10px 0 14px', padding: '14px 16px', background: 'rgba(6,14,40,0.55)', border: '1px solid rgba(56,189,248,0.12)', borderRadius: 12, fontFamily: 'inherit' }}>
      {/* Header */}
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 12 }}>
        <div>
          <span style={{ fontSize: 9.5, letterSpacing: '0.1em', textTransform: 'uppercase', color: 'rgba(56,189,248,0.55)', display: 'block', marginBottom: 3 }}>
            Projeto
          </span>
          <span style={{ fontSize: 14, fontWeight: 600, color: 'rgba(220,228,255,0.9)' }}>{name}</span>
        </div>
        <span style={{
          fontSize: 10, padding: '3px 9px', borderRadius: 20,
          background: 'rgba(16,185,129,0.1)', border: '1px solid rgba(16,185,129,0.25)',
          color: '#10b981', letterSpacing: '.03em',
        }}>
          {status}
        </span>
      </div>

      {/* Phase progress */}
      <div style={{ marginBottom: 12 }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 4 }}>
          <span style={{ fontSize: 11, color: 'rgba(172,196,236,0.6)' }}>Fase {phase} de {totalPhases}</span>
          <span style={{ fontSize: 11, color: '#818cf8', fontWeight: 600 }}>{pct}%</span>
        </div>
        <div style={{ height: 4, background: 'rgba(255,255,255,0.06)', borderRadius: 2, overflow: 'hidden' }}>
          <div style={{ width: `${pct}%`, height: '100%', background: 'linear-gradient(90deg,#818cf8,#38bdf8)', borderRadius: 2, transition: 'width .8s ease' }} />
        </div>
      </div>

      {/* Phase items */}
      {items.length > 0 && (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 5, marginBottom: nextAction ? 12 : 0 }}>
          {items.map((item, i) => (
            <div key={i} style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
              <span style={{ fontSize: 11, color: item.done ? '#10b981' : 'rgba(100,116,139,0.4)', flexShrink: 0 }}>
                {item.done ? '✓' : '○'}
              </span>
              <span style={{ fontSize: 12, color: item.done ? 'rgba(220,228,255,0.7)' : 'rgba(100,116,139,0.5)' }}>
                {item.label}
              </span>
            </div>
          ))}
        </div>
      )}

      {/* Next action */}
      {nextAction && (
        <div style={{ background: 'rgba(129,140,248,0.07)', border: '1px solid rgba(129,140,248,0.18)', borderRadius: 7, padding: '8px 12px' }}>
          <span style={{ fontSize: 10, color: '#818cf8', fontWeight: 600 }}>🚀 PRÓXIMA AÇÃO · </span>
          <span style={{ fontSize: 12, color: 'rgba(220,228,255,0.78)' }}>{nextAction}</span>
        </div>
      )}
    </div>
  );
}
